import {
	SET_PAYMENT_SUMMARY,
	SET_REPAIR_ORDER_ID,
	SET_REPAIR_ORDER_CUSTOMER
} from './repair-order-mutation-types';
import api from '@/services/api-service';
import buildRoute from '@/composables/build-route';
// import Vue from 'vue';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'repairOrder',
	namespaced: true,
	state: {
		repairOrderId: undefined,
		paymentSummary: undefined,
		repairOrderCustomer: undefined
	},
	mutations: {
		[SET_REPAIR_ORDER_ID](state, repairOrderId) {
			state.repairOrderId = repairOrderId;
		},
		[SET_PAYMENT_SUMMARY](state, paymentSummary) {
			state.paymentSummary = paymentSummary;
		},
		[SET_REPAIR_ORDER_CUSTOMER](state, repairOrderCustomer) {
			state.repairOrderCustomer = repairOrderCustomer;
		}
	},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch })
		async setPaymentSummaryAction({ commit }, paymentSummary) {
			commit(SET_PAYMENT_SUMMARY, paymentSummary);
		},
		async getPaymentSummaryAction(
			{ commit },
			{ companyId, repairOrderId }
		) {
			const paymentSummary = await api.get(
				buildRoute(
					'/service/company/{companyId}/repairorder/{id}/totals',
					{
						companyId: companyId,
						id: repairOrderId
					}
				)
			);

			commit(SET_PAYMENT_SUMMARY, paymentSummary);
			commit(SET_REPAIR_ORDER_ID, repairOrderId);
		},
		async getRepairOrderCustomerInfoAction(
			{ commit },
			{ companyId, repairOrderId }
		) {
			const repairOrderCustomer = await api.get(
				buildRoute(
					'/service/company/{companyId}/repairorder/{id}/customer',
					{
						companyId: companyId,
						id: repairOrderId
					}
				)
			);

			commit(SET_REPAIR_ORDER_CUSTOMER, repairOrderCustomer);
			commit(SET_REPAIR_ORDER_ID, repairOrderId);
		},
		async saveRepairOrderCustomerInfoAction(
			{ commit },
			{ companyId, repairOrderId, customerInfo }
		) {
			const repairOrderCustomer = await api.post(
				buildRoute(
					'/service/company/{companyId}/repairorder/{id}/customer',
					{
						companyId: companyId,
						id: repairOrderId
					}
				),
				customerInfo
			);

			commit(SET_REPAIR_ORDER_CUSTOMER, repairOrderCustomer);
			commit(SET_REPAIR_ORDER_ID, repairOrderId);
		}
	},
	getters: {
		repairOrderId: state => state.repairOrderId,
		paymentSummary: state => state.paymentSummary,
		paymentSummaryTotals: state => {
			let result;

			if (state.paymentSummary) {
				result = state.paymentSummary.total;
			}

			return result;
		},
		paymentSummaryTotalsWithCustomerDiscounts: state => {
			let result;

			if (state.paymentSummary) {
				result = state.paymentSummary.totalWithCustomerDiscounts;
			}

			return result;
		},
		repairOrderCustomer: state => state.repairOrderCustomer
	}
};
